var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAloneMarginRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#BFBFBF",
    t: 1641387455863,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 25614,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M478.72 723.2l211.2-211.2-211.2-211.2 60.373333-60.373333L810.666667 512 539.093333 783.573333zM298.666667 256h-85.333334v512h85.333334z",
    "p-id": 25615
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAloneMarginRight);
export default __webpack_public_path__ + "static/media/alone-margin-right.37709edb3ba07f87ca4d3a9a956a9bc8.svg";
export { ForwardRef as ReactComponent };